import React, { useState } from "react";
import { useEffect } from 'react';
import apiService from "../../service/apiService";
import { MenuItem, Select, InputLabel, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

import { useLocation } from 'react-router-dom';

import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";




const AddMarketLinkage = () => {
    const navigate = useNavigate(); // Hook for navigation
    const [seasonList, setSeasonList] = useState([]);
    const [seedClasses, setSeedClasses] = useState([]);
    const [seedClassList, setSeedClassList] = useState([]);
    const [seedList, setSeedList] = useState([]);
    const [varietyList, setVarietyList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [updatedBy, setUpdatedBy] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [rows, setRows] = useState([]);
    const [warning, setWarning] = useState(''); // For Sale Price warning
const [error, setError] = useState(''); // For Base Price error
const [formulaError, setFormulaError] = useState(''); // For formula validation error
const location = useLocation();

const { cropProductionMasterId } = location.state || {};
console.log("Crop Production Master kID:", cropProductionMasterId);
// const cropProductionMasterId = 20;  // Hardcoded value
// console.log("Crop Production Master ID:", cropProductionMasterId);



    const handleCloseDelete = () => {
        setOpenDelete(false);
        setUpdatedBy("");
        setSelectedRow(null);
    };


    const handleDeleteRow = async () => {
        try {
            const { id } = selectedRow;
            await apiService.delete(`/crop-plan-master/delete/${id}`, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            const updatedRows = rows.filter((row) => row.id !== id);
            setRows(updatedRows);
        } catch (error) {
            console.error("Error deleting data:", error);
        } finally {
            handleCloseDelete();
        }
    };

    const [casteList, setCasteList] = useState([]);

    useEffect(() => {
        const fetchCasteData = async () => {
            try {
                const response = await apiService.get('/castes/get-all');
                setCasteList(response.data);
            } catch (error) {
                console.error('Error fetching caste data:', error);
            }
        };
        const fetchSeasonData = async () => {
            try {
                const response = await apiService.get('/seasons/get-all');
                setSeasonList(response.data);
            } catch (error) {
                console.error('Error fetching season data:', error);
            }
        };

        const fetchSeedClassData = async () => {
            try {
                const response = await apiService.get('/seed-classes/get-all');
                setSeedClassList(response.data);
            } catch (error) {
                console.error('Error fetching seed class data:', error);
            }
        };

        const fetchSeedData = async () => {
            try {
                const response = await apiService.get('/seeds/get-all');
                const cleanedData = response.data.map((seed) => ({
                    ...seed,
                    seedName: seed.seedName.trim(), // Trim any extra whitespace
                }));
                setSeedList(cleanedData);
            } catch (error) {
                console.error('Error fetching seed data:', error);
            }
        };
        const fetchVarietyData = async () => {
            try {
                const response = await apiService.get('/seed-varieties/get-all');
                const cleanedData = response.data.map((variety) => ({
                    ...variety,
                    varietyName: variety.varietyName?.trim(), // Remove extra whitespace
                }));
                setVarietyList(cleanedData);
            } catch (error) {
                console.error('Error fetching variety data:', error);
            }
        };
        fetchVarietyData();

        fetchSeedData();

        fetchSeasonData();

        fetchSeedClassData();

        fetchCasteData();
    }, []);


    const [formData, setFormData] = useState({
        farmerName: "",
        caste: "",
        consumption: "",
        tlSeed:"",
        season: "",
        coverageArea: "",
        seedClass: "",
        seedName: "",
        varity: "",
        quanty: "",
        basePrice: "",
        totalPrice: "",
        salePrice: "",
    });

    const handleCancel = () => {
        navigate(-1);  // Go back to the previous page
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        console.log("Form Data Submitted:", formData);
    
        // Prepare the request body with cropProductionMasterId and marketLinkages
        const requestBody = {
            cropProductionMasterId: cropProductionMasterId,  // Include cropProductionMasterId from location.state
            marketLinkages: [
                {
                    cropProductionId: formData.cropProductionId,  // Make sure cropProductionId is part of formData
                    basePrice: parseFloat(formData.basePrice),
                    salePrice: parseFloat(formData.salePrice),
                    tlSeed: parseFloat(formData.tlSeed),
                    consumption: parseFloat(formData.consumption),
                },
            ],
        };
    
        try {
            // Send the POST request with the requestBody
            const response = await apiService.post('/market-linkage/create', requestBody);
            
            if (response.status === 200) {
                console.log("Market Linkage added successfully:", response.data);
                // Redirect or handle success (optional)
            } else {
                console.error("Failed to add Market Linkage:", response);
            }
        } catch (error) {
            console.error("Error during API request:", error);
        }
    };
    

    

    return (
        <Paper
            elevation={4}
            sx={{
                padding: 4,
                borderRadius: 2,
                height: "92vh", // Adjust height
                overflowY: "auto", // Handle overflow
            }}
        >
            <Typography
                variant="h3"
                gutterBottom
                align="center"
                sx={{
                    color: "#1976d2",
                    fontWeight: "bold",
                }}
            >
                Add Market Linkage
            </Typography>

            <Grid container spacing={3}>

              
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="TlSeed"
                        name="tlSeed"
                        value={formData.tlSeed}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="consumption"
                        name="consumption"
                        value={formData.consumption}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>
                
           
          

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Sale Price (Qtl)"
                        name="salePrice"
                        value={formData.salePrice}
                        onChange={(e) => {
                            const regex = /^[+]?\d+(\.\d{0,2})?$/;
                            const salePrice = e.target.value;
                            const basePrice = formData.basePrice;

                            // Ensure Sale Price is valid and handle additional logic
                            if (regex.test(salePrice)) {
                                if (basePrice === '' || parseFloat(salePrice) >= parseFloat(basePrice)) {
                                    // Valid sale price
                                    setWarning(''); // Clear any warnings
                                    handleChange(e);
                                } else {
                                    // Sale Price less than Base Price
                                    setWarning('Sale Price cannot be less than Base Price.');
                                }
                            } else {
                                // Invalid input
                                setWarning('');
                                handleChange({ target: { name: 'salePrice', value: '' } });
                            }
                        }}
                        variant="outlined"
                        required
                        inputProps={{ maxLength: 10 }}
                        helperText={warning}
                        error={!!warning} // Highlight field if there is a warning
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Base Price"
                        name="basePrice"
                        value={formData.basePrice}
                        onChange={(e) => {
                            const regex = /^[+]?\d+(\.\d{0,2})?$/;
                            const basePriceValue = e.target.value;

                            if (regex.test(basePriceValue)) {
                                // Update base price and reset errors or warnings
                                setWarning('');
                                setError('');
                                handleChange(e);
                            } else {
                                // Invalid Base Price
                                setError('Invalid input for Base Price.');
                                handleChange({ target: { name: 'basePrice', value: '' } });
                                handleChange({ target: { name: 'salePrice', value: '0' } }); // Reset Sale Price
                            }
                        }}
                        variant="outlined"
                        required
                        inputProps={{ maxLength: 10 }}
                        helperText={error}
                        error={!!error} // Highlight field if there is an error
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="body2" color="error">
                        {formulaError} {/* Display formula error if any */}
                    </Typography>
                </Grid>



                {/* Action Buttons */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end', // Align to the right
                            gap: 2,
                            mt: 3
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                paddingX: 3,
                                paddingY: 0.5,
                                height: "40px",
                                borderRadius: "20px",
                                backgroundColor: "#1976d2",
                                "&:hover": {
                                    backgroundColor: "#115293",
                                    boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
                                },
                                transition: "all 0.3s ease-in-out",
                            }}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCancel}
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                paddingX: 3,
                                paddingY: 0.5,
                                height: "40px",
                                borderRadius: "20px",
                                borderColor: "#f50057",
                                color: "#f50057",
                                "&:hover": {
                                    backgroundColor: "#ffe3ea",
                                    borderColor: "#c51162",
                                    color: "#c51162",
                                },
                                transition: "all 0.3s ease-in-out",
                            }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Grid>

            </Grid>

            {/* For delete the market-linkages */}

            <Dialog open={openDelete} onClose={handleCloseDelete}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to delete this description?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete} color="primary">Cancel</Button>
                    <Button onClick={handleDeleteRow} color="primary">Delete</Button>
                </DialogActions>
            </Dialog>

        </Paper>
    );
};

export default AddMarketLinkage;
